import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "./header/header";
import Footer from "./Footer";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "next-share";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { baseUrl, GetToken } from "../App";
import { BlogType } from "./type";

const site = "https://academy.doyenify.com";

function BlogDetails() {
const { blogId } = useParams<{
  blogId: string;
  slug: string;
}>();
  const [blog, setBlog] = useState<BlogType | null>(null);
  const [ready, setReady] = useState(false);
const { slug } = useParams<{ slug: string }>();

const createSlug = (title: string) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
};

const fetchBlogDetails = useCallback(async () => {
  try {
    const IdToken = await GetToken();

    const response = await axios.get(`${baseUrl}/blog-posts`, {
      headers: {
        Authorization: `Bearer ${IdToken}`,
      },
    });

    const blogs = response.data || [];

    const foundBlog = blogs.find(
      (item: BlogType) =>
        createSlug(item.Title) === slug
    );

    setBlog(foundBlog || null);
    setReady(true);

  } catch (error) {
    console.error("Error fetching blog:", error);
  }
}, [slug]);
  useEffect(() => {
    fetchBlogDetails();
  }, [fetchBlogDetails, blogId]);

  if (!ready) {
    return (
      <div className="academystyle">
        <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
        <ClipLoader size={25} color="#047E35" />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="container3">
        <div className="" style={{ zIndex: "51" }}>
          <div style={{ zIndex: "50" }}>
            <a
              href="/blogs"
              style={{
                marginTop: "2px",
                zIndex: "49",
                textDecoration: "none",
                textAlign: "center",
                backgroundColor: "#57e6b6",
                width: "130px",
                paddingLeft: "25px",
                paddingRight: "25px",
                paddingBottom: "8px",
                paddingTop: "10px",
                borderRadius: "50px",
                color: "#ffffff",
              }}
            >
              <FontAwesomeIcon
                style={{ textDecoration: "none", fontSize: "18px" }}
                icon={faArrowLeft}
              />{" "}
              Back
            </a>
          </div>
        </div>
        <h3 className="">{blog?.Date}</h3>
        <div>
          <h2>{blog?.Title}</h2>
          <p>
            Author: <span className="">{blog?.Author}</span>{" "}
          </p>
        </div>

        <div className="img-con">
          <img src={blog?.ArticleImage} alt="blog-pics" />
        </div>

        <div className="body1">
          {blog?.FullPost && (
            <div dangerouslySetInnerHTML={{ __html: blog.FullPost }} />
          )}
        </div>
        <div style={{ textAlign: "right" }} className="share-link">
          <FacebookShareButton
            // url={`${site}/blog/${blogId}`}
             url={`${site}/blog/${slug}`}
           
            
            quote={`${blog?.Title} - ${blog?.Date}`}
            title={`${blog?.Title} - ${blog?.Date}`}
            hashtag="#DoyenifyAcademyBlogs"
          >
            <div
              style={{
                backgroundColor: "#3b5998",
                borderRadius: "10px",
                paddingLeft: "7px",
                paddingRight: "7px",
                paddingTop: "3px",
                paddingBottom: "3px",
                marginRight: "5px",
              }}
            >
              <FacebookIcon size={32} round />
              <span style={{ paddingLeft: "0px", color: "#ffffff" }}>
                Share
              </span>
            </div>
          </FacebookShareButton>

          <LinkedinShareButton
            // url={`${site}/blog/${blogId}`}
             url={`${site}/blog/${slug}`}
            title={`${blog?.Title} - ${blog?.Date}`}
          >
            <div
              style={{
                backgroundColor: "#0072b1",
                borderRadius: "10px",
                paddingLeft: "7px",
                paddingRight: "7px",
                paddingTop: "3px",
                paddingBottom: "3px",
                marginRight: "5px",
              }}
            >
              <LinkedinIcon size={32} round />
              <span style={{ paddingLeft: "0px", color: "#ffffff" }}>
                Share
              </span>
            </div>
          </LinkedinShareButton>

          <WhatsappShareButton
            // url={`${site}/blog/${blogId}`}
             url={`${site}/blog/${slug}`}
            title={`${blog?.Title} - ${blog?.Date}`}
            separator=":: "
          >
            <div
              style={{
                backgroundColor: "#075e54",
                borderRadius: "10px",
                paddingLeft: "7px",
                paddingRight: "7px",
                paddingTop: "3px",
                paddingBottom: "3px",
                marginRight: "5px",
              }}
            >
              <WhatsappIcon size={32} round />
              <span style={{ paddingLeft: "0px", color: "#ffffff" }}>
                Share
              </span>
            </div>
          </WhatsappShareButton>

          <TwitterShareButton
            // url={`${site}/blog/${blogId}`}
             url={`${site}/blog/${slug}`}
            title={`${blog?.Title} - ${blog?.Date}`}
          >
            <div
              style={{
                backgroundColor: "#00acee",
                borderRadius: "10px",
                paddingLeft: "7px",
                paddingRight: "7px",
                paddingTop: "3px",
                paddingBottom: "3px",
                marginRight: "5px",
              }}
            >
              <TwitterIcon size={32} round />
              <span style={{ paddingLeft: "0px", color: "#ffffff" }}>
                Share
              </span>
            </div>
          </TwitterShareButton>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BlogDetails;
